function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgPlans5 = function SvgPlans5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 149 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10248_64198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6317 142.201C131.014 142.201 158.076 116.103 158.076 83.9092C158.076 51.7154 131.014 25.6172 97.6317 25.6172C64.2493 25.6172 37.1875 51.7154 37.1875 83.9092C37.1875 116.103 64.2493 142.201 97.6317 142.201Z",
    fill: "#2C4BD3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.5514 110.626C84.593 110.626 84.926 109.913 84.2505 108.114L78.4922 89.8385L122.818 64.478",
    fill: "#CBD9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5508 110.625C88.0619 110.625 88.7293 109.959 89.573 109.168L97.6322 101.61L87.5793 95.7642",
    fill: "#AFC9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.578 95.7662L111.937 113.122C114.717 114.601 116.723 113.835 117.415 110.634L127.331 65.5723C128.346 61.6473 125.779 59.8665 123.12 61.0309L64.8968 82.682C60.9226 84.2195 60.9463 86.3578 64.1725 87.3104L79.1138 91.8081L113.704 70.7623C115.337 69.8073 116.837 70.3202 115.606 71.3734",
    fill: "white"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10248_64198",
    x: 0.5875,
    y: 0.0171871,
    width: 182.089,
    height: 177.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.360628 0 0 0 0 0.468474 0 0 0 0 1 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10248_64198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10248_64198",
    result: "shape"
  }))));
};
export default SvgPlans5;